<template lang="pug">
  div(class='c-construction')
    //- figure(v-if='company.construction' class='c-construction__image', :style="{backgroundImage: 'url(' + company.construction + ')'}")
    progressive-background(:src='company.construction' v-if='company.construction' class='c-construction__image')

    figure(class='o-wrapper u-mb4 u-mt0' style='height: 60px')
      img(src="/images/logo_old.png", :alt="company.name" style='height:100%')

    div(class='u-flex u-items-center')
      hr(class='c-construction__loading', :width="percentage+ '%'")
      p(class='u-fw-bold u-fz-h4 u-mb0 u-mx2 u-mb0 u-mt0') {{ percentage }}%
      hr(class='u-flex-1 u-border-bottom')

    div(class='o-wrapper u-fz-h4')
      h1(class='c-construction__title u-fz-h0 u-mt3')
        span(class='u-line-1') Algo realmente bueno se viene
        strong(class='u-fw-s-bold u-line-1')  muy pronto

      p(class='u-fw-s-bold u-italic u-mb3') Contáctanos

      div(class='u-flex u-flex-wrap')
        span(v-if='company.email' class='u-mr3 u-mb1') C: {{company.email}}
        span(class='u-mr3 u-show@tablet') |
        span(v-if='company.cellphone') T: {{company.cellphone}}


      div(class='u-mt3 u-flex' v-if='company.facebookPage || company.twitterPage')
        a(:href='company.facebookPage', target='_blank', v-if='company.facebookPage', class='c-btn-share c-btn-share--facebook')
          i(class='u-icon') facebook
        a(:href='company.twitterPage', target='_blank', v-if='company.twitterPage', class='c-btn-share c-btn-share--twitter')
          i(class='u-icon') twitter
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ConstructionScreen',

    data () {
      return {
        percentage: 0,
        today: new Date(new Date().setHours(0, 0, 0)),
        startDate: new Date('10/21/2017'),
        endDate: new Date('1/1/2018')
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      getLoad () {
        const passedDays = parseInt(((this.today - this.startDate) / 24 / 3600 / 1000).toFixed(0), 10)
        const totalDays = (this.endDate - this.startDate) / 24 / 3600 / 1000
        const xDays = parseInt(((100 * passedDays) / totalDays).toFixed(0), 10)

        let interval = setInterval(() => {
          this.percentage++

          if (this.percentage >= xDays || this.percentage >= 99) {
            clearInterval(interval)
          }
        }, 50)
      }
    },

    mounted () {
      this.getLoad()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Construction/components/ConstructionScreen.vue